export const MEDIA_INPUT_KEYS = [
  'audio',
  'cdn01',
  'height',
  'image',
  'mimeType',
  'source',
  'video',
  'width',
] as const;
